<!-- 顶部菜单 -->
<template>
	<div class="">
		<!-- 切换平台和登录账号 -->
		<div class="iconBar" :style="smallPadding">
			<div style="float: left">
				<img style="margin-left: 20px; cursor: pointer;" src="@/assets/logo/sc_text_logo.png" alt="" @click="$router.push('/')"/>
			</div>
			<!-- 右侧菜单 -->
			<top-menu></top-menu>
		</div>
	</div>
</template>

<script>
import PageTab from '@/pageLayout/pageTab';
import TopMenu from '@/pageLayout/topMenu';
import { setToken, setUserId, getUserId, getLoginNumber, getUserName } from '@/utils/auth';

export default {
	name: 'navbar',
	components: {
		PageTab,
		TopMenu,
	},
	props: {
		keepAliveComponentData: {}, //keep-alive控件实例对象
		isCollapse: Boolean,
	},
	data() {
		return {
			levelList: null,
			loginName: '未登录',
			switchIcon: false,
			switchKefu: false,
			pwdDialog: false,
			currentUser: {},
			changePass: {
				oldPass: '',
				newPass: '',
				validatePass: '',
			},

			smallPadding: '',
		};
	},
	created() {
		this.switchIcon = this.isCollapse;

		if (document.body.clientWidth < 1200) this.smallPadding = 'padding: 18px;';
		else this.smallPadding = '';
	},
	mounted() {
		this.loginName = getUserName();
	},
	methods: {
		switchSidebar() {
			this.switchIcon = !this.switchIcon;
		},
		switchPlateform() {
			window.location.href = '/';
			// this.$router.push({
			// 	path: '/platformSelect'
			// })
		},
		close(e) {
			this.$refs.pagetab.onClose(e);
		},

		// 打开或隐藏客服面板
		showKefuBoard() {
			if (this.switchKefu) tccc.UI.hideWorkbench();
			else if (!this.switchKefu) tccc.UI.showWorkbench();

			this.switchKefu = !this.switchKefu;
		},
	},
	watch: {
		switchIcon() {
			this.$emit('update:isCollapse', this.switchIcon);
		},
	},
};
</script>

<style scoped>
.iconBar {
	height: 44px;
	padding: 18px 100px;
	margin: 0 -20px;
	box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
}
.iconBar .el-button {
	height: 30px;
	padding: 7px 20px;
	margin-left: 20px;
}
.iconBar i {
	font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pageLayout/navbar.vue